import React from "react";
import { useDispatch, useSelector } from "react-redux";

import ClientDeadlines from "../../components/deadlines/clientDeadlines";
import DeadlinesTable from "../../components/deadlines/table";
import { FEATURE_TOGGLE_TSPAY, TSDIGITAL_PORTALE_PUBLIC_URL } from "../../config";
import { FormattedMessage } from "react-intl";
import { useEffect } from "react";
import { useState } from "react";
import { loadAccounts } from "../../store/actions/tspay";
import Page from "../../components/general/page";
import CustomAlert from "../../components/general/customAlert";
import { useIntl } from "react-intl";
import { useLocation } from "react-router-dom";

const DeadlinesView = props => {
  const {        
    pageRef
  } = props;

  const auth = useSelector(state => state.auth);
  const company = useSelector(state => state.company);
  const main = useSelector(state => state.main);
  const tspay = useSelector(state => state.tspay);
  const tspayAccounts = tspay.accounts.list;
  const accountantUuidSelected = main.accountantUuidSelected;
  const accountantSelected = main.accountantSelected;
  const accountantIdSelected = main.accountantIdSelected;
  const companyUuidSelected = main.companyUuidSelected;
  const companySelected = main.companySelected;
  const clientIdSelected = main.clientIdSelected;
  const myType = main.myType;
  const prevPath = main.prevPath;

  const intl = useIntl();

  const dispatch = useDispatch();

  const location = useLocation();
  const [customersView, setCustomersView] = useState(myType === "STUDIO" ? null : "calendar");
  const [showToast, setShowToast] = useState(false);
  const [balanceDetailDialog, setBalanceDetailDialog] = useState(false);

  useEffect(() => {
    tspayAccounts.map(account => {
      if (new Date() > new Date(account.consentExpireDate)) {
        setShowToast(true);
      }
      return null;
    });
  }, [tspayAccounts]);

  const [configStatus, setConfigStatus] = useState("");

  useEffect(() => {
    setConfigStatus(tspay?.configStatus?.data?.status);
    if (tspay?.config?.data?.isEnabled && myType !== "STUDIO") {
      if (window.aptrinsic) {
        window.aptrinsic("track",
          "digital-box:DEADLINES-LIST-COMPANY-WITH-TSPAY");
      }
    }
  }, [tspay]);

  useEffect(() => {
    if (configStatus === "LINKED" && FEATURE_TOGGLE_TSPAY === "true") {
      dispatch(loadAccounts(
        auth, accountantUuidSelected, companyUuidSelected
      ));
    }
    if (window.aptrinsic) {
      window.aptrinsic("track",
        myType === "STUDIO"
          ? "digital-box:DEADLINES-LIST-STUDIO"
          : "digital-box:DEADLINES-LIST-COMPANY");
      if (
        window.location.href.indexOf("/scadenzecliente") === -1 &&
        myType === "STUDIO"
      ) {
        window.aptrinsic("track",
          "digital-box:DEADLINES-LIST-STUDIO-WITH-TSPAY");
      }
    }
  }, []);

  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    let viewType = null; 
    if (window.location.href.indexOf("/scadenzecliente") > -1){
      if (location?.state?.viewType){
        viewType= location?.state?.viewType;
      } else if (localStorage.getItem("customerViewType")){
        viewType = localStorage.getItem("customerViewType");
      } else {
        viewType = "calendar";
      }
    }    
    /*
    const viewType =
      window.location.href.indexOf("/scadenzecliente") > -1
        ? localStorage.getItem("customerViewType")
          ? localStorage.getItem("customerViewType")
          : "calendar"
        : null;
     */ 
    setCustomersView(viewType);
  }, []);

  useEffect(() => {
    if (
      window.location.href.indexOf("/scadenzecliente") > -1 &&
      myType === "STUDIO"
    ) {
      setCustomersView("calendar");
    }
  }, []);

  useEffect(() => {
    if (
      customersView === "cashFlow" &&
      myType === "STUDIO" &&
      window.location.href.indexOf("/scadenzecliente") > -1
    ) {
      if (window.aptrinsic){
        window.aptrinsic("track", "digital-box:DEADLINES-LIST-STUDIO-WITH-TSPAY");
      }
    }
  }, [customersView]);

  if (!auth || !accountantSelected || !companySelected) return null;

  const onSetBalanceModalVisibility = () => {
    setBalanceDetailDialog(true);
  };

  const linkTsVisible = myType === "STUDIO" ? TSDIGITAL_PORTALE_PUBLIC_URL + "#/"  : null;
  
  const objCompanySelected = company.companies
    ? company.companies.find(el => {
      return el.codiceFiscale === companySelected;
    })
    : null;

  const classifierCompanySelected = objCompanySelected
    ? objCompanySelected.classifier
    : null;

  const ragioneSociale = company?.companies?.find(el => {
    return el.codiceFiscale === companySelected;
  }).ragioneSociale;
  
  return (
    <Page
      pageRef={pageRef}
      className="contentStructure"      
      title={<FormattedMessage id="deadlines.title" />}
      subtitle={
        (myType === "STUDIO" &&
          window.location.href.indexOf("scadenzecliente") > -1) ||
        myType !== "STUDIO"
          ? ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + companySelected
          : ""
      }
      myType={myType}
      backText={
        myType === "STUDIO" &&
        window.location.href.indexOf("scadenzecliente") > -1 ? (
            <FormattedMessage id="deadlines.goClientList" />
          ) : (
            <FormattedMessage id="deadlines.goBack" />
          )
      }
      topHeaderContent={
        showToast &&
        (myType !== "STUDIO" ||
          (myType === "STUDIO" &&
            window.location.href.indexOf("scadenzecliente") > -1)) ? (
            <CustomAlert              
              msg1="customerPage.landing.tsPayAccountantAlertMsg1"
              buttonText="dashboard.detail"
              isTsPayOnboarding={false}
              isTsPayPackage={false}
              isTsPayAccountant={true}
              isDeadlinesView={true}
              onSetBalanceModalVisibility={onSetBalanceModalVisibility}
            />
          ) : null
      }
      backUrl={
        myType === "STUDIO" &&
        window.location.href.indexOf("scadenzecliente") > -1
          ? "/scheda-cliente"
          : "/"
      }
      backLocation={linkTsVisible}
    >
      {customersView &&
      (["graph", "calendar", "cashFlow"].includes(customersView)) ? (
          <ClientDeadlines
            accountantSelected={accountantSelected}
            accountantIdSelected={accountantIdSelected}
            auth={auth}
            company={company}
            companySelected={companySelected}
            clientIdSelected={clientIdSelected}            
            myType={myType}
            prevPath={prevPath}
            customersView={customersView}
            accountantUuidSelected={accountantUuidSelected}
            companyUuidSelected={companyUuidSelected}
            setCustomersView={setCustomersView}
            classifierCompanySelected={classifierCompanySelected}
            balanceDetailDialog={balanceDetailDialog}
            setBalanceDetailDialog={setBalanceDetailDialog}
          />
        ) : (
          <DeadlinesTable
            /** passo il riferimento al div della pagina per l'infinte scroll */
            pageRef={pageRef}            
            accountantSelected={accountantSelected}
            accountantIdSelected={accountantIdSelected}            
            companyUuidSelected={companyUuidSelected}
            customersView={customersView}
            companySelected={companySelected}
            clientIdSelected={clientIdSelected}
            myType={myType}
            prevPath={prevPath}
            setCustomersView={setCustomersView}
            classifierCompanySelected={classifierCompanySelected}
            balanceDetailDialog={balanceDetailDialog}
            setBalanceDetailDialog={setBalanceDetailDialog}
          />
        )}
    </Page>
  );
};

export default DeadlinesView;
